/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log( 'Hello World! (from furmanos-blocks-furmanos-blocks block)' );
/* eslint-enable no-console */
// document.addEventListener('DOMContentLoaded', () => {
//     const prod_cats = document.querySelectorAll('.product-categories');
//     prod_cats.forEach(prod_cats =>{
//         const groups = prod_cats.querySelectorAll('.product-categories__group');
//         groups.forEach(group=>{
//             group.addEventListener('click',(e)=>{
//                 e.preventDefault;
//                 const link = e.target.dataset?.link;
//                 if(link){
//                     window.location.href = link;
//                 }
//             })
//         });
//     });
// });
import './style.scss';
